module.exports = __webpack_public_path__ + "img/play.0d924b0e.svg";